import numeral from 'numeral';

export default (value: number) => {
    const isExponential = value.toString().toLowerCase().includes('e');
    if (isExponential) {
        return value;
    }
    return numeral(value).format('0,0.[0000]a').toUpperCase();
};
